import DestinationImagePage from '~/components/Content/DestinationImage/DestinationImagePage';
import ManualExperienceLocationList from '~/components/Content/ManualExperienceLocations/ManualExperienceLocationList';
import ViewBlockedOffers from '~/components/Content/OfferBlocklist/ViewBlockedOffers';
import PolygonMergeContainer from '~/components/Content/PolygonMerge/PolygonMergeContainer';
import PropertyLocationOverrideList from '~/components/Content/PropertyLocationOverride/PropertyLocationOverrideList';
import RestoreSearchDashboard from '~/components/Content/RestoreSearchDashboard/RestoreSearchDashboard';
import TrendingPlacesPage from '~/components/Content/TrendingPlaces/TrendingPlacesPage';

import GeometrySearch from './GeometrySearch';
import NaturalLanguageSearchPage from './NaturalLanguageSearch/NaturalLanguageSearchPage';
import OfferListOrder from './OfferListOrder/OfferListOrderContainer';
import SearchRankingPage from './SearchRanking/SearchRankingPage';

export const curationTabs = {
  'offer-list-order': {
    title: 'Offer List Order',
    component: OfferListOrder,
  },
  'trending-places': {
    title: 'Trending Places',
    component: TrendingPlacesPage,
  },
  'destination-image': {
    title: 'Destination Image',
    component: DestinationImagePage,
  },
  'manual-experience-locations': {
    title: 'Manual Experience Locations',
    component: ManualExperienceLocationList,
  },
} as const;

export const searchCurationTabs = {
  'search-dashboard': {
    title: 'Search Dashboard',
    component: GeometrySearch,
  },
  'search-ranking': {
    title: 'Search Ranking',
    component: SearchRankingPage,
  },
  'blocked-offers': {
    title: 'Blocked offers',
    component: ViewBlockedOffers,
  },
  'property-location-override': {
    title: 'Property Location Override',
    component: PropertyLocationOverrideList,
  },
  'nl-search': {
    title: 'Natural Language Search',
    component: NaturalLanguageSearchPage,
  },
  'restore-search-dashboard': {
    title: 'Restore Search Dashboard',
    component: RestoreSearchDashboard,
  },
  'polygon-merge': {
    title: 'Polygon Merge',
    component: PolygonMergeContainer,
  },
} as const;

export const curationTabsList = Object.keys(curationTabs);
export const searchCurationTabsList = Object.keys(searchCurationTabs);

export type CurationTab = keyof typeof curationTabs;
export type SearchCurationTab = keyof typeof searchCurationTabs;
